export default __webpack_public_path__ + "static/media/USDB.ec1343f5.png";